// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `loading .loading-container,
motes-loading .loading-container,
mini-loading .loading-container {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  transform: translateY(-50%);
  text-align: center;
  pointer-events: none !important;
}
loading .loading-container .svg-icon,
motes-loading .loading-container .svg-icon,
mini-loading .loading-container .svg-icon {
  line-height: 1em;
  color: white;
  font-size: 78px;
}
loading .loading-container .svg-icon svg,
motes-loading .loading-container .svg-icon svg,
mini-loading .loading-container .svg-icon svg {
  animation: spin 1.5s ease infinite;
  font-size: inherit;
  display: inline-block;
  fill: currentColor;
  stroke: currentColor;
  width: 1em;
  height: 1em;
  overflow: visible;
}
loading .loading-container p,
motes-loading .loading-container p,
mini-loading .loading-container p {
  color: white;
  font-family: Gothic;
  font-size: 15px;
  font-weight: bold;
  margin-top: 0;
  text-align: center !important;
  -webkit-user-select: none;
          user-select: none;
  text-shadow: 0px 0px 5px rgba(34, 34, 34, 0.5);
}
loading .mini-loading-container,
motes-loading .mini-loading-container,
mini-loading .mini-loading-container {
  text-align: center;
  font-size: inherit;
  line-height: 1;
}
loading .spin-animation svg,
motes-loading .spin-animation svg,
mini-loading .spin-animation svg {
  animation: spin 1.5s ease infinite;
}
loading .color-animation,
motes-loading .color-animation,
mini-loading .color-animation {
  animation: color-spin 2s ease-out infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@keyframes color-spin {
  0% {
    color: white;
  }
  50% {
    color: var(--motes-gold);
  }
  100% {
    color: white;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/loading/loading.scss"],"names":[],"mappings":"AAGI;;;EACI,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,2BAAA;EACA,kBAAA;EACA,+BAAA;AAAR;AAEQ;;;EACI,gBAAA;EACA,YAAA;EACA,eAAA;AAEZ;AACQ;;;EACI,kCAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;AAGZ;AADQ;;;EACI,YAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,6BAAA;EACA,yBAAA;UAAA,iBAAA;EACA,8CAAA;AAKZ;AADI;;;EACI,kBAAA;EACA,kBAAA;EACA,cAAA;AAKR;AAFI;;;EACI,kCAAA;AAMR;AAHI;;;EACI,0CAAA;AAOR;AAJI;EACI;IAEI,uBAAA;EAMV;EAJM;IAEI,yBAAA;EAMV;AACF;AAHI;EACI;IACI,YAAA;EAKV;EAHM;IACI,wBAAA;EAKV;EAHM;IACI,YAAA;EAKV;AACF","sourcesContent":["loading,\nmotes-loading,\nmini-loading {\n    .loading-container {\n        text-align: center;\n        position: absolute;\n        top: 50%;\n        left: 0;\n        width: 100%;\n        transform: translateY(-50%);\n        text-align: center;\n        pointer-events: none !important;\n\n        .svg-icon {\n            line-height: 1em;\n            color: white;\n            font-size: 78px;\n        }\n\n        .svg-icon svg {\n            animation: spin 1.5s ease infinite;\n            font-size: inherit;\n            display: inline-block;\n            fill: currentColor;\n            stroke: currentColor;\n            width: 1em;\n            height: 1em;\n            overflow: visible;\n        }\n        p {\n            color: white;\n            font-family: Gothic;\n            font-size: 15px;\n            font-weight: bold;\n            margin-top: 0;\n            text-align: center !important;\n            user-select: none;\n            text-shadow: 0px 0px 5px rgb(34 34 34 / 50%);\n        }\n    }\n\n    .mini-loading-container {\n        text-align: center;\n        font-size: inherit;\n        line-height: 1;\n    }\n\n    .spin-animation svg {\n        animation: spin 1.5s ease infinite;\n    }\n\n    .color-animation {\n        animation: color-spin 2s ease-out infinite;\n    }\n\n    @keyframes spin {\n        0% {\n            -webkit-transform: rotate(0deg);\n            transform: rotate(0deg);\n        }\n        100% {\n            -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n        }\n    }\n\n    @keyframes color-spin {\n        0% {\n            color: white;\n        }\n        50% {\n            color: var(--motes-gold);\n        }\n        100% {\n            color: white;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
